import { demoFile, feature } from 'system/demo';

demoFile('feature/question/embedded');

feature('embedded', {
    structureKey: 'question',
});
